<template>
  <div class="page-header">
    <div class="page-header-start">
      <div
        v-if="back"
        class="page-header-start-icon"
        @click="$emit('onBack')"
        v-html="iconBack"
      />
      <div class="page-header-start-title h1">
        {{ title }}
      </div>
    </div>
    <div class="page-header-end">
      <slot name="end" />
    </div>
  </div>
</template>

<script>
/**
 * Заголовок страницы (область контента)
 * @module Shared/Component/PageHeader
 * @vue-event {$event} onBack - клик по кнопке "Назад"
 * @vue-prop {String} title - Заголовок
 * @vue-prop {Boolean} back - Наличие кнопки "Назад"
 * */

import iback from 'Images/icon/ic-back.svg'

export default {
  name: 'VuePageHeaderBack',
  props: {
    title: String,
    back: Boolean
  },
  data: () => ({
    iconBack: iback
  })
}
</script>

<style lang="scss">
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $color-text-base;
  flex-wrap: wrap;
  $gutter-size: 30px;
  margin-left: -$gutter-size;

  &-start, &-end {
    padding-left: $gutter-size;
    > * {
      margin-bottom: $gutter-size;
    }
  }

  &-start {
    display: flex;
    align-items: center;

    &-icon {
      padding-right: 20px;
      width: 50px;
      height: 30px;
      cursor: pointer;
    }

    &-icon:hover {
      opacity: 0.6;
    }
  }

  &-end {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    button,
    .q-btn,
    .q-field__control {
      height: 44px !important;
    }

    .q-field__label {
      top: 12px;
      font-size: 16px;
    }

    > * {
      min-width: 150px;

      &:not(:only-child):not(:last-child) {
        margin-right: 30px;
      }
    }
  }

  @media screen and (max-width: $breakpoint-lg-max){
    $gutter-size: 18px;
    margin-left: -$gutter-size;

    &-start, &-end {
      padding-left: $gutter-size;
      > * {
        margin-bottom: $gutter-size;
      }
    }
  }

  @media screen and (max-width: $breakpoint-xs-max) {
    padding: 0 15px;
    padding-bottom: 10px;

    &-start {
      margin-bottom: 15px;

      > * {
        margin-bottom: 8px;
      }
    }

    &-end {
      margin-bottom: 0;
      > * {
        margin-bottom: 12px;
        width: 100%;
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }

    &-start, &-end {
      width: 100%;
    }
  }
}
</style>
